import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';
import { blogPosts, postHref, SERIES } from './blogPosts';
import './Blog.css';

function metaLine(post) {
  const series = post.series ? `${SERIES[post.series].name} · Part ${post.part}` : null;
  return [post.category, series, post.date, post.readTime].filter(Boolean);
}

const BlogList = () => {
  const featuredPost = blogPosts.find((post) => post.featured) || blogPosts[0];
  const regularPosts = blogPosts.filter((post) => post !== featuredPost);

  return (
    <div className="news-page">
      <div className="news-inner">
        <header className="news-head">
          <h1>Blog</h1>
          <p className="news-aside">
            Stories from building Panda.{' '}
            <Link to="/changelog">Product updates live in the changelog.</Link>
          </p>
        </header>

        {featuredPost && (
          <Link to={postHref(featuredPost)} className="news-featured">
            <p className="news-meta">
              {metaLine(featuredPost).map((part) => (
                <span key={part}>{part}</span>
              ))}
            </p>
            <h2>{featuredPost.title}</h2>
            <p className="news-excerpt">{featuredPost.excerpt}</p>
          </Link>
        )}

        <ul className="news-list">
          {regularPosts.map((post) => (
            <li key={post.id}>
              <Link to={postHref(post)} className="news-item">
                <p className="news-meta">
                  {metaLine(post).map((part) => (
                    <span key={part}>{part}</span>
                  ))}
                </p>
                <h2>{post.title}</h2>
                <p className="news-excerpt">{post.excerpt}</p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <Footer />
    </div>
  );
};

export default BlogList;
